"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleApp = void 0;
var Config_1 = require("../../app/Config");
var store_1 = require("../../app/store");
var firebase_1 = require("../../app/utils/firebase");
var user_state_1 = require("../../app/utils/user-state");
var FaceTecSDK_1 = require("./../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var AuthenticateProcessor_1 = require("./processors/AuthenticateProcessor");
var EnrollmentProcessor_1 = require("./processors/EnrollmentProcessor");
var LivenessCheckProcessor_1 = require("./processors/LivenessCheckProcessor");
var PhotoIDMatchProcessor_1 = require("./processors/PhotoIDMatchProcessor");
var PhotoIDScanProcessor_1 = require("./processors/PhotoIDScanProcessor");
var AdditionalScreens_1 = require("./utilities/AdditionalScreens");
var DeveloperStatusMessages_1 = require("./utilities/DeveloperStatusMessages");
var SampleAppUtilities_1 = require("./utilities/SampleAppUtilities");
var SiteBrandingCustomization_1 = require("./utilities/SiteBrandingCustomization");
var ThemeHelpers_1 = require("./utilities/ThemeHelpers");
exports.SampleApp = (function () {
    var latestEnrollmentIdentifier = "";
    var latestProcessor;
    var latestSessionResult = null;
    var latestIDScanResult = null;
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = function () {
        SampleAppUtilities_1.SampleAppUtilities.formatUIForDevice();
        // Set absolute directory paths for FaceTec Browser SDK Resources
        // Absolute paths ensure correct resolution on nested routes like /site/:id
        FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
        FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
        console.log("FaceTecApp -> window.onload");
        console.log("FaceTecApp -> window.onload -> Config.didSucceed", Config_1.Config.didSucceed);
        console.log("FaceTecApp -> window.onload -> Config", Config_1.Config.ProductionKeyText, "and", Config_1.Config.DeviceKeyIdentifier);
        /**@TODO @Desmond Fix context switch error when the weeb-app tries to redirect automatically */
        SampleAppUtilities_1.SampleAppUtilities.fadeInMainUIContainer();
    };
    // Clear previous session results;
    function initializeResultObjects() {
        latestSessionResult = null;
        latestIDScanResult = null;
    }
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        initializeResultObjects();
        // Re-apply current tenant's branding immediately before every session
        // so the overlay reflects whichever site the user is currently on
        // (see facetec/src/utilities/SiteBrandingCustomization.ts).
        (0, SiteBrandingCustomization_1.applySiteBrandingToFaceTec)();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.
        getSessionToken(function (sessionToken) {
            latestProcessor = new LivenessCheckProcessor_1.LivenessCheckProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Initiate a 3D Liveness Check, then storing the 3D FaceMap in the Database, also known as "Enrollment".  A random enrollmentIdentifier is generated each time to guarantee uniqueness.
    function onEnrollUserPressed() {
        var _a, _b, _c;
        initializeResultObjects();
        (0, SiteBrandingCustomization_1.applySiteBrandingToFaceTec)();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Resolve Firebase UID for the enrolment identifier. Prefer the live
        // non-anonymous Firebase Auth user — it's the only source guaranteed
        // to be in sync with the SDK's own session right now. Redux/local
        // storage/profile cache can lag during bootstrap and would otherwise
        // pin enrolment to a stale UID. Anonymous sessions are skipped because
        // their ghost UIDs have no backing Firestore profile and the backend
        // can never verify them.
        var clientAuthUser = firebase_1.auth.currentUser;
        var clientAuthUid = clientAuthUser && !clientAuthUser.isAnonymous ? clientAuthUser.uid : "";
        var reduxState = store_1.store.getState();
        var userState = (0, user_state_1.getCurrentUserState)();
        var firebaseUid = clientAuthUid ||
            ((_a = reduxState.auth) === null || _a === void 0 ? void 0 : _a.firebase_user_id) ||
            localStorage.getItem("firebase_user_id") ||
            (userState === null || userState === void 0 ? void 0 : userState.uid) ||
            ((_c = (_b = reduxState.userProfile) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.uid) ||
            "";
        // Get a Session Token from the FaceTec SDK, then start the Enrollment.
        getSessionToken(function (sessionToken) {
            // Include Firebase UID in the identifier for cross-referencing on FaceTec platform
            var uniqueId = SampleAppUtilities_1.SampleAppUtilities.generateUUId();
            latestEnrollmentIdentifier = firebaseUid
                ? "lewfin_".concat(firebaseUid, "_").concat(uniqueId)
                : "lewfin_browser_app_".concat(uniqueId);
            latestProcessor = new EnrollmentProcessor_1.EnrollmentProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform 3D to 3D Authentication against the Enrollment previously performed.
    function onAuthenticateUserPressed() {
        var _a;
        initializeResultObjects();
        var userState = (0, user_state_1.getCurrentUserState)();
        latestEnrollmentIdentifier = (_a = userState === null || userState === void 0 ? void 0 : userState.facetecDBRef) !== null && _a !== void 0 ? _a : "";
        console.log("Latest Enrollment Identifier:", latestEnrollmentIdentifier);
        // For demonstration purposes, verify that we have an enrollmentIdentifier to Authenticate against.
        if (latestEnrollmentIdentifier.length === 0) {
            DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Please enroll first before trying authentication.");
        }
        else {
            (0, SiteBrandingCustomization_1.applySiteBrandingToFaceTec)();
            SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
            // Get a Session Token from the FaceTec SDK, then start the 3D to 3D Matching.
            getSessionToken(function (sessionToken) {
                latestProcessor = new AuthenticateProcessor_1.AuthenticateProcessor(sessionToken, exports.SampleApp);
            });
        }
    }
    // Perform a 3D Liveness Check, then an ID Scan, then Match the 3D FaceMap to the ID Scan.
    function onPhotoIDMatchPressed() {
        initializeResultObjects();
        (0, SiteBrandingCustomization_1.applySiteBrandingToFaceTec)();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        var userState = (0, user_state_1.getCurrentUserState)();
        latestEnrollmentIdentifier = userState.facetecDBRef;
        console.log("Latest Enrollment Identifier:", latestEnrollmentIdentifier);
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken(function (sessionToken) {
            //latestEnrollmentIdentifier = "skylifestyle_browser_app_" + SampleAppUtilities.generateUUId();
            latestProcessor = new PhotoIDMatchProcessor_1.PhotoIDMatchProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform Photo ID Scan, generating a username each time to guarantee uniqueness.
    function onPhotoIDScanPressed() {
        initializeResultObjects();
        (0, SiteBrandingCustomization_1.applySiteBrandingToFaceTec)();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken(function (sessionToken) {
            latestProcessor = new PhotoIDScanProcessor_1.PhotoIDScanProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Show the final result with the Session Review Screen.
    var onComplete;
    onComplete = function (sessionResult, idScanResult, latestNetworkResponseStatus) {
        latestSessionResult = sessionResult;
        latestIDScanResult = idScanResult;
        if (latestProcessor.isSuccess()) {
            // Display message to user, Success messages are already logged from the processors.
            DeveloperStatusMessages_1.DeveloperStatusMessages.displayMessage("See logs for details");
        }
        else {
            // Log result for unSuccess Sessions.
            DeveloperStatusMessages_1.DeveloperStatusMessages.logScanOncompleteResult(sessionResult, idScanResult);
            // Check for server offline
            if (isNetworkResponseServerIsOffline(latestNetworkResponseStatus) === true) {
                showAdditionalScreensServerIsDown();
                return;
            }
        }
        SampleAppUtilities_1.SampleAppUtilities.showMainUI();
    };
    // Check for server down status
    function isNetworkResponseServerIsOffline(networkResponseStatus) {
        return networkResponseStatus >= 500;
    }
    // Set a new customization for FaceTec Browser SDK.
    function onDesignShowcasePressed() {
        ThemeHelpers_1.ThemeHelpers.showNewTheme();
    }
    function onVocalGuidanceSettingsButtonPressed() {
        SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceMode();
    }
    // Display audit trail images captured from user's last FaceTec Browser SDK Session (if available).
    function onViewAuditTrailPressed() {
        SampleAppUtilities_1.SampleAppUtilities.showAuditTrailImages(latestSessionResult, latestIDScanResult);
    }
    var sessionTokenErrorHasBeenHandled = false;
    function onSessionTokenError(xhrStatus) {
        if (sessionTokenErrorHasBeenHandled === false) {
            sessionTokenErrorHasBeenHandled = true;
            if (xhrStatus !== undefined &&
                isNetworkResponseServerIsOffline(xhrStatus)) {
                showAdditionalScreensServerIsDown();
            }
            else {
                onServerSessionTokenError();
            }
        }
    }
    // Get the Session Token from the server
    function getSessionToken(sessionTokenCallback) {
        sessionTokenErrorHasBeenHandled = false;
        //TODO - Add .content
        try {
            var XHR = new XMLHttpRequest();
            XHR.open("GET", Config_1.Config.BaseURL + "/session-token");
            XHR.setRequestHeader("X-Device-Key", Config_1.Config.DeviceKeyIdentifier);
            XHR.setRequestHeader("X-User-Agent", FaceTecSDK_1.FaceTecSDK.createFaceTecAPIUserAgentString(""));
            XHR.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    var sessionToken = "";
                    try {
                        // Attempt to get the sessionToken from the response object.
                        sessionToken = JSON.parse(this.responseText).content.sessionToken;
                        // Something went wrong in parsing the response. Return an error.
                        if (typeof sessionToken !== "string") {
                            onSessionTokenError(XHR.status);
                            return;
                        }
                    }
                    catch (_a) {
                        // Something went wrong in parsing the response. Return an error.
                        XHR.abort();
                        onSessionTokenError(XHR.status);
                        return;
                    }
                    SampleAppUtilities_1.SampleAppUtilities.hideLoadingSessionToken();
                    sessionTokenCallback(sessionToken);
                }
            };
            // Wait 3s, if the request is not completed yet, show the session token loading screen
            window.setTimeout(function () {
                if (XHR.readyState !== XMLHttpRequest.DONE) {
                    if (sessionTokenErrorHasBeenHandled === false) {
                        SampleAppUtilities_1.SampleAppUtilities.showLoadingSessionToken();
                    }
                }
            }, 3000);
            XHR.onerror = function () {
                XHR.abort();
                onSessionTokenError(XHR.status);
            };
            XHR.send();
        }
        catch (e) {
            onSessionTokenError(undefined);
        }
    }
    function showAdditionalScreensServerIsDown() {
        AdditionalScreens_1.AdditionalScreens.showServerUpGradeView();
    }
    function onServerSessionTokenError() {
        SampleAppUtilities_1.SampleAppUtilities.handleErrorGettingServerSessionToken();
    }
    var getLatestEnrollmentIdentifier = function () {
        return latestEnrollmentIdentifier;
    };
    var clearLatestEnrollmentIdentifier = function () {
        latestEnrollmentIdentifier = "";
    };
    // Set the enrollment identifier (used when syncing from Firebase)
    var setLatestEnrollmentIdentifier = function (identifier) {
        latestEnrollmentIdentifier = identifier;
        console.log("📝 Updated enrollment identifier to:", identifier);
    };
    // Called when enrollment is required (after failed authentication with no valid reference)
    var onEnrollmentRequired = function () {
        console.log("🔐 Enrollment required - triggering enrollment flow");
        // Trigger the enrollment flow
        onEnrollUserPressed();
    };
    function exitAdditionalScreen() {
        AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
    }
    return {
        onLivenessCheckPressed: onLivenessCheckPressed,
        onEnrollUserPressed: onEnrollUserPressed,
        onAuthenticateUserPressed: onAuthenticateUserPressed,
        onPhotoIDMatchPressed: onPhotoIDMatchPressed,
        onPhotoIDScanPressed: onPhotoIDScanPressed,
        onDesignShowcasePressed: onDesignShowcasePressed,
        onComplete: onComplete,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        clearLatestEnrollmentIdentifier: clearLatestEnrollmentIdentifier,
        setLatestEnrollmentIdentifier: setLatestEnrollmentIdentifier,
        onEnrollmentRequired: onEnrollmentRequired,
        onVocalGuidanceSettingsButtonPressed: onVocalGuidanceSettingsButtonPressed,
        onViewAuditTrailPressed: onViewAuditTrailPressed,
        latestSessionResult: latestSessionResult,
        latestIDScanResult: latestIDScanResult,
        get latestProcessor() {
            return latestProcessor;
        },
    };
})();
